module.exports = __webpack_public_path__ + "static/img/arrow-down-red.27bf9d68.svg";